<template>
  <b-modal
    v-model="isVisible"
    :data-cy="isVisible ? 'company-change-subscription-modal' : ''"
    centered
    modal-class="cy-current-item-modal"
    hide-footer
    hide-header
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-container fluid>
      <b-row align-v="center">
        <b-col md="12" class="flex-row d-flex">
          <div
            class="
              d-flex
              flex-column
              justify-content-center
              position-relative
              mt-3
            "
          >
            <p
              class="
                cy-current-item-name
                font-family-medium
                subtext
                primary--text
                mt-2
              "
            >
              Changing Subscription for {{ name }}
            </p>
          </div>
        </b-col>
      </b-row>

      <b-row class="pt-2 pl-4 d-flex flex-column mb-4 mt-3">
        <h4 class="font-md cy-current-item-subtext">
          Update the subscription from
          <span
            class="
              text-uppercase
              danger--light danger
              font-family-medium
              chip--pill
            "
          >
            {{ initial }}
          </span>
          to
          <span
            class="
              text-uppercase
              danger--light danger
              font-family-medium
              chip--pill
            "
          >
            {{ intended }}
          </span>
          ?
        </h4>
      </b-row>

      <b-row v-if="isFlexibleHours" class="d-flex flex-column px-4 pt-1 pb-5">
        <ValidationObserver ref="observer">
          <ValidationProvider
            name="'Subscription Hours'"
            rules="required"
            v-slot="{ errors }"
          >
            <b-form-group
              class="position-relative"
              label="Subscription hours per month*"
            >
              <b-form-input
                v-model="subscriptionHours"
                data-cy="company-change-subscription-modal-hours"
                autocomplete="off"
                placeholder="Enter subscription hours"
                type="number"
                min="0"
              ></b-form-input>
            </b-form-group>

            <h6
              v-if="errors[0]"
              class="font-sm font-family-regular position-absolute danger"
            >
              {{ errors[0] }}
            </h6>
          </ValidationProvider>
        </ValidationObserver>
      </b-row>

      <b-row class="d-flex justify-content-end pb-3 pt-4 pr-3">
        <b-button
          class="
            cy-current-item-archive
            btn btn-pill
            px-5
            py-3
            ml-2
            reduce-whitespace
          "
          data-cy="company-change-subscription-modal-cancel"
          @click="emitCancellationAndClose"
        >
          Cancel
        </b-button>
        <b-button
          class="
            cy-current-item-archive
            btn-danger btn-pill
            px-5
            py-3
            ml-2
            reduce-whitespace
          "
          data-cy="company-change-subscription-modal-confirm"
          @click="emitConfirmationAndClose(id)"
        >
          {{ confirmButtonText }}
        </b-button>
      </b-row>

      <b-row v-if="error" class="archive-error">
        <b-col> {{ error }}</b-col>
      </b-row>
    </b-container>
  </b-modal>
</template>

<script>
import {
  ValidationObserver,
  ValidationProvider
} from "vee-validate/dist/vee-validate.full";

import { getInitialsFromName } from "@/utils/utils";

export default {
  components: {
    ValidationObserver,
    ValidationProvider
  },

  props: {
    id: { type: String },
    name: { type: String },
    error: { type: String },
    canClose: { type: Boolean }
  },

  data() {
    return {
      isVisible: false,

      initial: "",
      initialId: "",
      intended: "",
      intendedId: "",
      isFlexibleHours: false,

      subscriptionHours: null
    };
  },

  computed: {
    actionLabel() {
      return "Confirm";
    },

    confirmButtonText() {
      const [first, ...rest] = this.actionLabel.split("");
      return `${first.toUpperCase()}${rest.join("")}`;
    }
  },

  watch: {
    // * For the confirm button, we close only if
    canClose(can) {
      if (can) {
        this.close();
      }
    }
  },

  methods: {
    getInitialsFromName,

    open(initialId, initial, intended, intendedId, isFlexibleHours = false) {
      this.isVisible = true;
      this.isFlexibleHours = isFlexibleHours;

      this.initial = initial;
      this.initialId = initialId;
      this.intended = intended;
      this.intendedId = intendedId;
    },

    close() {
      this.isVisible = false;
      this.initial = "";
      this.intended = "";
      this.isFlexibleHours = false;
      this.subscriptionHours = null;
    },

    async emitConfirmationAndClose(id) {
      const hasObserver = !!this.$refs.observer;
      if (hasObserver) {
        const isNotValid = !(await this.$refs.observer.validate());
        if (isNotValid) {
          return;
        }
      }

      this.$emit(
        "update-confirmed",
        id,
        this.intendedId,
        this.intended,
        this.subscriptionHours
      );
    },

    emitCancellationAndClose() {
      this.$emit("update-cancelled");
      this.close();
    },

    closeAndClear() {
      this.close();
    }
  }
};
</script>

<style scoped>
button.btn.close-btn {
  right: -2.5rem;
  top: -2rem;
  background: none;
}
</style>